<template>
  <el-dialog
    :close-on-click-modal="false"
    title="离职"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  driverArchivesQuit,
} from 'api/archives';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        levelConfigIdOptions: [],
        form: [
          {
            label: '离职时间',
            value: 'dimissionDate',
            type: 'date',
            placeholder: '请选择离职时间',
            attr: {
              time: '00:00:00',
            },
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() > Date.now();

              },
            },
          },
          {
            label: '离职原因',
            value: 'remark',
            type: 'input',
            placeholder: '请输入离职原因，最多100字',
            attr: {
              type: 'textarea',
              maxlength: 100,
            },
          },
        ],
        rules: { // 表单验证规则
          dimissionDate: [ // 离职时间
            { required: true, message: '请选择离职时间', trigger: 'blur' },
          ],
          remark: [ // 离职原因
            { required: true, message: '请输入离职原因', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      if (item) { // 修改
        this.type = 'edit';
        this.originData = item;
      } else { // 新增
        this.type = 'add';
      }
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await driverArchivesQuit({
        userId: this.originData.userId,
        dimissionDate: this.formatDate(form.dimissionDate),
        remark: form.remark,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
